// extracted by mini-css-extract-plugin
module.exports = {"container":"ParentPlayer_container__1kEcQ","title":"ParentPlayer_title__1UYD8","description":"ParentPlayer_description__33Y7I"};